// extracted by mini-css-extract-plugin
module.exports = {"moreInfo":"rk","link":"rl","linkText":"rm","linkIcon":"rn","isRental":"ro","active":"rp","synopsisAndButton":"rq","linkWrapper":"rr"};